import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { PureComponent } from 'react';
import { ContextualSurvey as AkContextualSurvey, DismissTrigger } from '@atlaskit/contextual-survey';
const flagKey = 'atlassian_research_group_mailinglist_actioned';

// eslint-disable-next-line @repo/internal/react/no-class-components
export default class ContextualSurvey extends PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "onDismiss", onDismissArgs => {
      const {
        cloudId,
        messageId,
        fireClickEvent,
        stargateUrl,
        markAsSeenAndFatigued,
        orgId,
        workspaceId
      } = this.props;
      if (onDismissArgs.trigger === DismissTrigger.Manual) {
        markAsSeenAndFatigued({
          stargateUrl,
          cloudId,
          messageId,
          orgId,
          workspaceId
        });
      }
      fireClickEvent('dismiss');
    });
    _defineProperty(this, "getUserHasAnsweredMailingList", async () => {
      const {
        stargateUrl,
        aaid,
        cloudId,
        getFlag
      } = this.props;
      try {
        await getFlag(stargateUrl, cloudId, flagKey, aaid);
        return Promise.resolve(false);
      } catch {
        return Promise.resolve(true);
      }
    });
    _defineProperty(this, "onSubmit", async formValues => {
      const {
        cloudId,
        messageId,
        question,
        statement,
        stargateUrl,
        markAsSeenAndFatigued,
        sendUserResponse,
        orgId,
        workspaceId
      } = this.props;
      const {
        canContact,
        feedbackScore,
        writtenFeedback
      } = formValues;
      const payload = {
        responseType: 'ACCEPTANCE_SURVEY',
        properties: {
          surveyTimestamp: Date.now(),
          contextualQuestion: question,
          contextualStatement: statement,
          quantitativeResponse: feedbackScore,
          qualitativeResponse: writtenFeedback,
          contactable: canContact
        }
      };
      markAsSeenAndFatigued({
        stargateUrl,
        cloudId,
        messageId,
        orgId,
        workspaceId
      });
      this.firePrimaryClickEvent();

      // Resolving the promise to ensure that spinner of Submit button does not spin forever in case of errors
      return sendUserResponse(cloudId, stargateUrl, messageId, payload).catch(() => Promise.resolve());
    });
    _defineProperty(this, "onMailingListAnswer", async answer => {
      const {
        aaid,
        cloudId,
        stargateUrl,
        messageId,
        sendUserResponse,
        setFlag
      } = this.props;
      const payload = {
        responseType: 'MAILING_LIST_RESPONSE',
        properties: {}
      };
      setFlag(stargateUrl, cloudId, flagKey, aaid);
      if (!answer) {
        return;
      }
      return sendUserResponse(cloudId, stargateUrl, messageId, payload);
    });
  }
  firePrimaryClickEvent() {
    this.props.fireClickEvent('primary');
  }
  render() {
    return /*#__PURE__*/React.createElement(AkContextualSurvey, _extends({
      onDismiss: this.onDismiss,
      getUserHasAnsweredMailingList: this.getUserHasAnsweredMailingList,
      onMailingListAnswer: this.onMailingListAnswer,
      onSubmit: this.onSubmit
    }, this.props));
  }
}